import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "@/guards/auth";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/views/theme/Base"),
            children: [
                {
                  path: "/profile",
                  name: "profile",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/profile/Profile.vue"),
                  meta: {
                      permissions: []
                  }
                },
                {
                    path: "/dashboard",
                    name: "dashboard",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dashboard/Dashboard.vue"),
                    meta: {
                        permissions: []
                    }
                },
                {
                    path: "/offer",
                    name: "offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/offer/Offer.vue"),
                    meta: {
                        permissions: ['offers-create']
                    }
                },
                {
                    path: "/offer/:id",
                    name: "edit-offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/offer/EditOffer.vue"),
                    meta: {
                        permissions: ['offers-edit']
                    }
                },
                {
                    path: "/quick-offer",
                    name: "new-quick-offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/quickOffer/NewQuickOffer.vue"),
                    meta: {
                        permissions: ['offers-create']
                    }
                },
                {
                    path: "/quick-offer/:id",
                    name: "update-quick-offer",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/quickOffer/UpdateQuickOffer.vue"),
                    meta: {
                        permissions: ['offers-edit'],
                        hideSubheader: true,
                        fluidContainer: true
                    }
                },
                {
                  path: "/live-list",
                  name: "live-list",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/liveList/LiveList.vue"),
                  meta: {
                      permissions: ['live-list-view-all']
                  }
                },
                {
                  path: "/price-lists",
                  name: "price-lists",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/priceLists/ListPriceLists.vue"),
                  meta: {
                      permissions: ['price-lists-view-self', 'price-lists-view-team', 'price-lists-view-all']
                  }
                },
                {
                  path: "/price-lists/create",
                  name: "price-lists-create",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/priceLists/EditPriceList.vue"),
                  meta: {
                      permissions: ['price-lists-create']
                  }
                },
                {
                  path: "/price-lists/:id",
                  name: "price-lists-edit",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/priceLists/EditPriceList.vue"),
                  meta: {
                      permissions: ['price-lists-view-self', 'price-lists-view-team', 'price-lists-view-all']
                  }
                },
                {
                    path: "/users",
                    name: "users",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/Users.vue"),
                    meta: {
                        permissions: ['users-view-self', 'users-view-team', 'users-view-all']
                    }
                },
                {
                    path: "users/new-user",
                    name: "new-user",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/StoreUser.vue"),
                    meta: {
                        permissions: ['users-create']
                    }
                },
                {
                    path: "users/:id/edit",
                    name: "edit-user",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/StoreUser.vue"),
                    meta: {
                        permissions: ['users-edit']
                    }
                },
                {
                    path: "users/:id",
                    name: "view-user",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/users/ViewUser.vue"),
                    meta: {
                        permissions: ['users-view-self', 'users-view-team', 'users-view-all']
                    }
                },
                {
                    path: "/teams",
                    name: "teams",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/Teams.vue"),
                    meta: {
                        permissions: ['teams-view-self', 'teams-view-team', 'teams-view-all']
                    }
                },
                {
                    path: "teams/new-team",
                    name: "new-team",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/StoreTeam.vue"),
                    meta: {
                        permissions: ['teams-create']
                    }
                },
                {
                    path: "teams/:id/edit",
                    name: "edit-team",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/StoreTeam.vue"),
                    meta: {
                        permissions: ['teams-edit']
                    }
                },
                {
                    path: "teams/:id",
                    name: "view-team",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/teams/ViewTeam.vue"),
                    meta: {
                        permissions: ['teams-view-self', 'teams-view-team', 'teams-view-all']
                    }
                },
                {
                    path: "/companies",
                    name: "companies",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/ListCompanies.vue"),
                    meta: {
                        permissions: ['companies-view-all']
                    }
                },
                {
                    path: "companies/create",
                    name: "companies-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/EditCompany.vue"),
                    meta: {
                        permissions: ['companies-create']
                    }
                },
                {
                    path: "companies/:id/edit",
                    name: "companies-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/EditCompany.vue"),
                    meta: {
                        permissions: ['companies-edit']
                    }
                },
                {
                    path: "companies/:id",
                    name: "companies-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companies/ViewCompany.vue"),
                    meta: {
                        permissions: ['companies-view-all']
                    }
                },
                {
                    path: "/company-contacts",
                    name: "company-contacts",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/ListCompanyContacts.vue"),
                    meta: {
                        permissions: ['company-contacts-view-all']
                    }
                },
                {
                    path: "company-contacts/create",
                    name: "company-contacts-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/EditCompanyContact.vue"),
                    meta: {
                        permissions: ['company-contacts-create']
                    }
                },
                {
                    path: "company-contacts/:id/edit",
                    name: "company-contacts-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/EditCompanyContact.vue"),
                    meta: {
                        permissions: ['company-contacts-edit']
                    }
                },
                {
                    path: "company-contacts/:id",
                    name: "company-contacts-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/companyContacts/ViewCompanyContact.vue"),
                    meta: {
                        permissions: ['company-contacts-view-all']
                    }
                },
                {
                    path: "/pipelines-list",
                    name: "pipelines",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/ListPipelines.vue"),
                    meta: {
                        permissions: ['pipelines-view-all']
                    }
                },
                {
                    path: "pipelines/create",
                    name: "pipelines-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/EditPipeline.vue"),
                    meta: {
                        permissions: ['pipelines-create']
                    }
                },
                {
                    path: "pipelines/:id/edit",
                    name: "pipelines-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/EditPipeline.vue"),
                    meta: {
                        permissions: ['pipelines-edit']
                    }
                },
                {
                    path: "pipelines/:id",
                    name: "pipelines-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pipelines/ViewPipeline.vue"),
                    meta: {
                        permissions: ['pipelines-view-all'],
                        hideSubheader: true,
                        fluidContainer: true
                    }
                },
                {
                    path: "/deals-list",
                    name: "deals-list",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/deals/ListDeals.vue"),
                    meta: {
                        permissions: ['deals-view-all', 'deals-view-self']
                    }
                },
                {
                    path: "/deal-statuses",
                    name: "deal-statuses",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/ListDealStatuses.vue"),
                    meta: {
                        permissions: ['deal-statuses-view-all']
                    }
                },
                {
                    path: "deal-statuses/create",
                    name: "deal-statuses-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/EditDealStatus.vue"),
                    meta: {
                        permissions: ['deal-statuses-create']
                    }
                },
                {
                    path: "deal-statuses/:id/edit",
                    name: "deal-statuses-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/EditDealStatus.vue"),
                    meta: {
                        permissions: ['deal-statuses-edit']
                    }
                },
                {
                    path: "deal-statuses/:id",
                    name: "deal-statuses-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealStatuses/ViewDealStatus.vue"),
                    meta: {
                        permissions: ['deal-statuses-view-all']
                    }
                },
                {
                    path: "/deal-document-types",
                    name: "deal-document-types",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/ListDealDocumentTypes.vue"),
                    meta: {
                        permissions: ['deal-document-types-view-all']
                    }
                },
                {
                    path: "deal-document-types/create",
                    name: "deal-document-types-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/EditDealDocumentType.vue"),
                    meta: {
                        permissions: ['deal-document-types-create']
                    }
                },
                {
                    path: "deal-document-types/:id/edit",
                    name: "deal-document-types-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/EditDealDocumentType.vue"),
                    meta: {
                        permissions: ['deal-document-types-edit']
                    }
                },
                {
                    path: "deal-document-types/:id",
                    name: "deal-document-types-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealDocumentTypes/ViewDealDocumentType.vue"),
                    meta: {
                        permissions: ['deal-document-types-view-all']
                    }
                },
                {
                    path: "/deal-types",
                    name: "deal-types",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/ListDealTypes.vue"),
                    meta: {
                        permissions: ['deal-types-view-all']
                    }
                },
                {
                    path: "deal-types/create",
                    name: "deal-types-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/EditDealType.vue"),
                    meta: {
                        permissions: ['deal-types-create']
                    }
                },
                {
                    path: "deal-types/:id/edit",
                    name: "deal-types-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/EditDealType.vue"),
                    meta: {
                        permissions: ['deal-types-edit']
                    }
                },
                {
                    path: "deal-types/:id",
                    name: "deal-types-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/dealTypes/ViewDealType.vue"),
                    meta: {
                        permissions: ['deal-types-view-all']
                    }
                },
                {
                    path: "/list-offers",
                    name: "list-offers",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/listOffers/ListOffers.vue"),
                    meta: {
                        permissions: ['offers-view-self', 'offers-view-team', 'offers-view-all'],
                        hideSubheader: true,
                        fluidContainer: true
                    }
                },
                {
                    path: "aliases",
                    name: "aliases",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/aliases/ShowAliases.vue"),
                    meta: {
                        permissions: []
                    }
                },
                {
                    path: "aliases/:id",
                    name: "edit-alias",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/aliases/EditAlias.vue"),
                    meta: {
                        permissions: ['aliases-edit']
                    }
                },
                {
                    path: "mappings",
                    name: "mappings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/mappings/ShowMappings.vue"),
                    meta: {
                        permissions: ['mappings-view-self', 'mappings-view-team', 'mappings-view-all']
                    }
                },
                {
                    path: "mapping/:id",
                    name: "edit-mappings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/mappings/EditMapping.vue"),
                    meta: {
                        permissions: ['mappings-edit']
                    }
                },
                {
                    path: "mapping",
                    name: "create-mappings",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/mappings/EditMapping.vue"),
                    meta: {
                        permissions: ['mappings-create']
                    }
                },
                {
                  path: "mapping-values/:mappingId",
                  name: "edit-mapping-values",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/mappings/EditMappingValues.vue"),
                  meta: {
                      permissions: ['mapping-values-view-self', 'mapping-values-view-team', 'mapping-values-view-all']
                  }
              },
                {
                    path: "/unit-conversions",
                    name: "unit-conversions",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/ListUnitConversions.vue"),
                    meta: {
                        permissions: ['unit-conversions-view-all']
                    }
                },
                {
                    path: "unit-conversions/create",
                    name: "unit-conversions-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/EditUnitConversion.vue"),
                    meta: {
                        permissions: ['unit-conversions-create']
                    }
                },
                {
                    path: "unit-conversions/:id/edit",
                    name: "unit-conversions-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/EditUnitConversion.vue"),
                    meta: {
                        permissions: ['unit-conversions-edit']
                    }
                },
                {
                    path: "unit-conversions/:id",
                    name: "unit-conversions-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/unitConversions/ViewUnitConversion.vue"),
                    meta: {
                        permissions: ['unit-conversions-view-all']
                    }
                },
                {
                  path: "transport-data",
                  name: "transport-data",
                  beforeEnter: AuthGuard,
                  component: () => import("@/views/pages/transportData/ShowTransportData.vue"),
                  meta: {
                      permissions: ['transport-data-view-self', 'transport-data-view-team', 'transport-data-view-all']
                  }
                },
                {
                    path: "price-config",
                    name: "price-config",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/config/Config.vue"),
                    meta: {
                        permissions: ['price-config-self', 'price-config-team', 'price-config-all']
                    }
                },
                {
                    path: "/field-tag-types",
                    name: "field-tag-types",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/ListFieldTagTypes.vue"),
                    meta: {
                        permissions: ['field-tags-view-all']
                    }
                },
                {
                    path: "/field-tag-types/:fieldTagTypeId/tags",
                    name: "field-tags",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/ListFieldTags.vue"),
                    meta: {
                        permissions: ['field-tags-view-all']
                    }
                },
                {
                    path: "field-tag-types/:fieldTagTypeId/tags/create",
                    name: "field-tags-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/EditFieldTag.vue"),
                    meta: {
                        permissions: ['field-tags-create']
                    }
                },
                {
                    path: "field-tag-types/:fieldTagTypeId/tags/:tagId/edit",
                    name: "field-tags-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/EditFieldTag.vue"),
                    meta: {
                        permissions: ['field-tags-edit']
                    }
                },
                {
                    path: "field-tag-types/:fieldTagTypeId/tags/:tagId",
                    name: "field-tags-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/fieldTags/ViewFieldTag.vue"),
                    meta: {
                        permissions: ['field-tags-view-all']
                    }
                },
                {
                    path: "/incoterms",
                    name: "incoterms",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/ListIncoterms.vue"),
                    meta: {
                        permissions: ['incoterms-view-all']
                    }
                },
                {
                    path: "incoterms/create",
                    name: "incoterms-create",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/EditIncoterm.vue"),
                    meta: {
                        permissions: ['incoterms-create']
                    }
                },
                {
                    path: "incoterms/:id/edit",
                    name: "incoterms-edit",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/EditIncoterm.vue"),
                    meta: {
                        permissions: ['incoterms-edit']
                    }
                },
                {
                    path: "incoterms/:id",
                    name: "incoterms-view",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/incoterms/ViewIncoterm.vue"),
                    meta: {
                        permissions: ['incoterms-view-all']
                    }
                },
                {
                    path: "list-price",
                    name: "pricing",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pricing/ShowPricing.vue"),
                    meta: {
                        permissions: ['pricing-view-self', 'pricing-view-team', 'pricing-view-all']
                    }
                },
                {
                    path: "pricing/:id",
                    name: "edit-pricing",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pricing/EditPricing.vue"),
                    meta: {
                        permissions: ['pricing-edit']
                    }
                },
                {
                    path: "pricing",
                    name: "create-pricing",
                    beforeEnter: AuthGuard,
                    component: () => import("@/views/pages/pricing/EditPricing.vue"),
                    meta: {
                        permissions: ['pricing-create']
                    }
                }
            ]
        },
        {
            path: "/",
            component: () => import("@/views/pages/auth/Auth"),
            children: [
                {
                    name: "login",
                    path: "/login",
                    component: () => import("@/views/pages/auth/Login")
                },
                {
                    name: "register",
                    path: "/register",
                    component: () => import("@/views/pages/auth/Register")
                },
                {
                    name: "forgot",
                    path: "/forgot",
                    component: () => import("@/views/pages/auth/Forgot")
                },
                {
                    name: "reset",
                    path: "/reset/:token/:email",
                    component: () => import("@/views/pages/auth/Reset")
                }
            ]
        },
        {
          path: "/google-redirect",
          name: "google-redirect",
          component: () => import("@/views/pages/auth/GoogleRedirect")
        },
        {
            path: "*",
            redirect: "/404",
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/views/pages/error/Error-1.vue")
        }
    ]
});
